/**
 * Хранение реферального кода из URL (?ref=CODE) до момента вызова API авторизации.
 * Сохраняется в sessionStorage при переходе по реферальной ссылке.
 */

const REFERRAL_CODE_KEY = 'referral_code';
const VISITOR_ID_KEY = 'referral_visitor_id';

export function getReferralCode(): string | null {
  try {
    return sessionStorage.getItem(REFERRAL_CODE_KEY);
  } catch {
    return null;
  }
}

export function setReferralCode(code: string): void {
  try {
    sessionStorage.setItem(REFERRAL_CODE_KEY, code);
  } catch {}
}

export function clearReferralCode(): void {
  try {
    sessionStorage.removeItem(REFERRAL_CODE_KEY);
  } catch {}
}

export function getOrCreateVisitorId(): string {
  try {
    let id = localStorage.getItem(VISITOR_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(VISITOR_ID_KEY, id);
    }
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

export function buildShareableReferralLink(baseLink: string, visitorId?: string): string {
  const id = visitorId ?? getOrCreateVisitorId();
  try {
    const url = new URL(baseLink, window.location.origin);
    url.searchParams.set('id', id);
    return url.toString();
  } catch {
    const separator = baseLink.includes('?') ? '&' : '?';
    return `${baseLink}${separator}id=${encodeURIComponent(id)}`;
  }
}
